module.exports = __webpack_public_path__ + "img/home_en_primeur_fr.788015c.png";